import { FC, useEffect } from 'react';
import TableModule from './TableModule';
import {
  StoreImageCostConfig,
  StoreImageCostNames,
  CoreInfoRelateNames
} from '../ts-config';
import { Form } from 'antd';
import { isNotEmpty } from '@lhb/func';
import { fieldNameStoreImageCost } from './fieldname';
import { fixIntParam } from './transfer2value';

/**
 * @Description 店铺形象成本
 */
const StoreImageCost: FC<{
  form: any;
  formItemData: any;
  disabled?: boolean;
  onChange: any;
}> = ({
  form,
  formItemData,
  disabled,
  onChange
}) => {
  // 提报合同面积
  const basicUsableArea: any = Form.useWatch(
    CoreInfoRelateNames.basicUsableArea,
    form
  );

  // 道具单价
  const propsPrice: any = Form.useWatch(
    fieldNameStoreImageCost(StoreImageCostNames.propsPrice),
    form
  );

  // 灯具单价
  const lampPrice: any = Form.useWatch(
    fieldNameStoreImageCost(StoreImageCostNames.lampPrice),
    form
  );

  // 店铺形象费用
  useEffect(() => {
    const name = fieldNameStoreImageCost(StoreImageCostNames.storeImageCost);
    const val: any = calcStoreImageCost(propsPrice, lampPrice, basicUsableArea);
    form.setFieldValue(name, val);
  }, [propsPrice, lampPrice, basicUsableArea]);

  /**
   * @description 店铺形象费用
   * @param propsPrice
   * @param lampPrice
   * @param basicUsableArea
   * @return
   *   （道具单价+灯具单价）*提报合同面积/2/1.13
   */
  const calcStoreImageCost = (propsPrice, lampPrice, basicUsableArea) => {
    let val: any = null;
    // 已填写面积，并填写至少一项单价时才有计算结果
    if (isNotEmpty(basicUsableArea) && (isNotEmpty(propsPrice) || isNotEmpty(lampPrice))) {
      let unitPrice: number = 0;
      isNotEmpty(propsPrice) && (unitPrice += (+propsPrice));
      isNotEmpty(lampPrice) && (unitPrice += (+lampPrice));

      val = fixIntParam(unitPrice * (+basicUsableArea) / 2 / 1.13);
    }
    return val;
  };

  // 道具总价
  useEffect(() => {
    const name = fieldNameStoreImageCost(StoreImageCostNames.propsTotal);
    const val: any = calcPropsTotal(propsPrice, basicUsableArea);
    form.setFieldValue(name, val);
  }, [propsPrice, basicUsableArea]);

  /**
   * @description 道具总价
   * @param propsPrice
   * @param basicUsableArea
   * @return
   *   道具单价*提报合同面积
   */
  const calcPropsTotal = (propsPrice, basicUsableArea) => {
    return isNotEmpty(basicUsableArea) && isNotEmpty(propsPrice) ? fixIntParam((+basicUsableArea) * (+propsPrice)) : null;
  };

  // 灯具总价
  useEffect(() => {
    const name = fieldNameStoreImageCost(StoreImageCostNames.lampTotal);
    const val: any = calcLampTotal(lampPrice, basicUsableArea);
    form.setFieldValue(name, val);
  }, [lampPrice, basicUsableArea]);

  /**
   * @description 灯具总价
   * @param lampPrice
   * @param basicUsableArea
   * @return
   *   灯具单价*提报合同面积
   */
  const calcLampTotal = (lampPrice, basicUsableArea) => {
    return isNotEmpty(basicUsableArea) && isNotEmpty(lampPrice) ? fixIntParam((+basicUsableArea) * (+lampPrice)) : null;
  };

  return (
    <TableModule
      moduleConfig={StoreImageCostConfig}
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default StoreImageCost;
